import { isArray } from '@/utils/validate'
import userHasPermission from '@/utils/user-has-permission'

/**
 *
 * @param routes
 * @param targetPath
 * @returns {*|null}
 */
const findRouteByPath = (routes, targetPath) => {
  if (!isArray(routes) || !targetPath) {
    return null
  }

  for (const route of routes) {
    if (
      route.path === targetPath &&
      userHasPermission(route.meta?.permissions)
    ) {
      return route
    }

    const foundChildRoute = findRouteByPath(route.children, targetPath)

    if (foundChildRoute) {
      return foundChildRoute
    }
  }

  return null
}

/**
 * Extracts the domain (e.g., test.com) from a given hostname.
 * @param {string} hostname - The full hostname (e.g., asdbasd0-asd.test.com).
 * @returns {string|null} - The extracted domain (e.g., test.com) or null if invalid.
 */
const getDomainFromHostname = () => {
  if (typeof window?.location?.hostname !== 'string') {
    return null
  }

  const match = window?.location?.hostname?.match(/[^.]+\.[^.]+$/)

  return match ? match[0] : null
}

export { findRouteByPath, getDomainFromHostname }
